import React, { useEffect, useState } from "react";
import { img_path } from "../../../environment";

interface Image {
  className?: string;
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  id?: string;
  fullSrc?: string;
  style?: React.CSSProperties;
}

const ImageWithBasePath = (props: Image) => {
  // fullSrc is often a remote/presigned URL (S3 logos, profile pictures) that
  // can fail to load — expired, network error, whatever. If it does, fall
  // back to the bundled local asset instead of a permanently broken image.
  const [remoteFailed, setRemoteFailed] = useState(false);
  // A new fullSrc (e.g. switching campus) deserves a fresh attempt, not the
  // previous URL's failure carried over.
  useEffect(() => setRemoteFailed(false), [props.fullSrc]);
  const localSrc = `${img_path}${props.src}`;
  const fullSrc = props.fullSrc && !remoteFailed ? props.fullSrc : localSrc;
  return (
    <img
      className={props.className}
      src={fullSrc}
      height={props.height}
      alt={props.alt}
      width={props.width}
      id={props.id}
      style={props.style}
      onError={() => {
        if (props.fullSrc && !remoteFailed) setRemoteFailed(true);
      }}
    />
  );
};

export default ImageWithBasePath;
